export default "__VITE_ASSET__417c49f1__"